import { gql, useMutation } from '@apollo/client';

const TOGGLE_AUDIT_POLICY_SNIPPET_APPROVAL = gql`
  mutation ToggleAuditPolicySnippetApproval($id: String!, $approved: Boolean!) {
    toggleAuditPolicySnippetApproval(id: $id, approved: $approved)
  }
`;

export interface ToggleAuditPolicySnippetApprovalVariables {
  id: string;
  approved: boolean;
}

export interface ToggleAuditPolicySnippetApprovalData {
  toggleAuditPolicySnippetApproval: boolean;
}

export function useToggleAuditPolicySnippetApprovalMutation() {
  return useMutation<ToggleAuditPolicySnippetApprovalData, ToggleAuditPolicySnippetApprovalVariables>(
    TOGGLE_AUDIT_POLICY_SNIPPET_APPROVAL
  );
}
